import http from '@/utils/http'
export async function requestFundsLedger (params) {
  const body = await http.post('/api/trade/fundsLedger', params, { loading: false, direct: true })
  if (body.code !== 200) throw new Error(body.msg || body.message || '请登录对应用户中心账户后查询资金流水。')
  if (!body.data || String(body.data.account_no) !== String(params.expected_account_no)) throw new Error('交易账户不一致，请使用对应用户中心账户登录。')
  return body.data
}
